export const LOCAL_STORAGE_CONFIG = { key:"BusaboutAPC"};

//CURRENCY FALLBACK
export const CURRENCY_FALLBACK = {iso_currency_code: "USD", currency: "Dollar", currency_mask: "$#,##0.00 "};
export const DEVELOPMENT_CURRENCY = {data:{"response_info":null,"iso_country_code":"GB","country":"UK","dialing_code":"+44","currency_info":{"iso_currency_code":"GBP","currency":"GBP","currency_mask":"£#,##0.00 "}}};


//CREATE YOUR OWN ADVENTURE
export const CYOA_NETWORK_IDS = {
    "europe":{ id:"CYO", name:"europe"},
    "usa": { id: "CYU", name:"usa"}
}

//REGIONAL ADDRESS
export const OFFICE_ADDRESS = {
    "AUD":{
        telephone:"1300287226",
        email:"customers@busabout.com",
        address:"Busabout, HAGGiS, Shamrocker, Travel House, 35 Grafton St, Bondi Junction, Sydney NSW 2022"
    },
    "NZD":{
        telephone:"0508 287 226",
        email:"customers@busabout.com",
        address:"Busabout, HAGGiS, Shamrocker, 131 New North Road, Eden Terrace, Auckland"
    },
    "USD":{
        telephone:"+1 877 668 4328",
        email:"travel@busabout.com",
        address:"Busabout, HAGGiS, Shamrocker, Travel House, 33 Kern Road, Toronto, M3B 1S9, Ontario, Canada"
    },
    "CAD":{
        telephone:"+1 877 668 4328",
        email:"travel@busabout.com",
        address:"Busabout, HAGGiS, Shamrocker, Travel House, 33 Kern Road, Toronto, M3B 1S9, Ontario, Canada"
    },
    "GBP":{
        telephone:"44 (0) 808 281 1114",
        email:"info@busabout.com",
        address:"Travel House, Rue du Manoir, St Peter Port, Guernsey, Channel Islands, GY1 2JH"
    },
    "EUR":{
        telephone:"+44 (0) 808 281 1114",
        email:"info@busabout.com",
        address:"Travel House, Rue du Manoir, St Peter Port, Guernsey, Channel Islands, GY1 2JH"
    },
    "ZAR":{
        telephone:"+27 11 280 8400",
        email:"letsgo@busabout.com",
        address:"Busabout, HAGGiS, Shamrocker, 3rd floor, The Travel House, 6 Hood Ave, Rosebank 2196"
    }
}


export const POPULAR_COUNTRIES = [
    "Australia", "United States", "Canada", "United Kingdom", "New Zealand", "South Africa", "Germany", "France", "Poland", "Portugal", "Spain", "Greece"
  ]